import React from 'react';
import { ArrowLeft, ArrowsLeftRight } from 'phosphor-react';

interface SkinPhotoComparisonHeaderProps {
  photoCount: number;
  onBack: () => void;
  onCompare: () => void;
}

export default function SkinPhotoComparisonHeader({ photoCount, onBack, onCompare }: SkinPhotoComparisonHeaderProps) {
  return (
    <header className="bg-white dark:bg-gray-900 shadow-soft dark:border-b dark:border-gray-700 px-5 pt-12 pb-5">
      <div className="max-w-lg mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="p-2 -ml-2 text-nude-400 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-xl transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
              Comparador de Fotos
            </h1>
            <p className="text-sm text-nude-500 dark:text-gray-400 mt-0.5">
              {photoCount > 0
                ? `${photoCount} foto${photoCount > 1 ? 's' : ''} disponíve${photoCount > 1 ? 'is' : 'l'}`
                : 'Nenhuma foto ainda'}
            </p>
          </div>
        </div>

        {photoCount >= 2 && (
          <button
            onClick={onCompare}
            className="animate-scale-in flex items-center gap-1.5 px-3 py-2 bg-blush-400 hover:bg-blush-500 text-white text-xs font-semibold rounded-xl transition-colors shadow-sm"
          >
            <ArrowsLeftRight className="w-3.5 h-3.5" />
            Comparar
          </button>
        )}
      </div>
    </header>
  );
}
